import { VideoReportingState, VideoReportingStates } from "./types";

export function getDefaultState(): VideoReportingState {
	return {
		videoReportingState: VideoReportingStates.PreSearch,
		videoReportingPrefs: {
			maxCameras: 5,
			maxDistance: 2,
			maxDuration: 10,
			maxWorkers: 10
		},
		currentReport: {
			eventId: null,
			videoReportId: null,
			reviewsComplete: 0,
			camerasComplete: 0
		},
		auditEndpoint: null,
		deviceEventRecords: {}
	};
}
